import { render, staticRenderFns } from "./MemberTable.vue?vue&type=template&id=f2561986"
import script from "./MemberTable.vue?vue&type=script&lang=js"
export * from "./MemberTable.vue?vue&type=script&lang=js"
import style0 from "./MemberTable.vue?vue&type=style&index=0&id=f2561986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports